(function () {
  'use strict';

  function hasClass(el, name) {
    return el && (' ' + el.className + ' ').indexOf(' ' + name + ' ') !== -1;
  }

  function addClass(el, name) {
    if (!el) return;
    if (el.classList) el.classList.add(name);
    else if (!hasClass(el, name)) el.className += ' ' + name;
  }

  function removeClass(el, name) {
    if (!el) return;
    if (el.classList) el.classList.remove(name);
    else el.className = (' ' + el.className + ' ').replace(' ' + name + ' ', ' ').replace(/^\s+|\s+$/g, '');
  }

  function closestSlide(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      if (hasClass(node, 'swiper-slide')) return node;
      node = node.parentNode;
    }
    return null;
  }

  function each(list, fn) {
    var i;
    for (i = 0; i < list.length; i += 1) fn(list[i], i);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function initHero(root) {
    if (!root || root.getAttribute('data-kkm-universal-ready') === 'true') return;
    root.setAttribute('data-kkm-universal-ready', 'true');

    var slideContent = root.querySelectorAll('[data-kkm-hero-slide]');
    if (!slideContent.length) return;

    var wrappers = [];
    each(slideContent, function (slide) {
      var wrapper = closestSlide(slide);
      if (wrapper) wrappers.push(wrapper);
    });
    if (!wrappers.length) return;

    var sliderElement = root.querySelector('slider-carousel');
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && wrappers.length > 1;
    var pauseOnHover = root.getAttribute('data-pause-on-hover') === 'true';
    var timer = null;
    var swiper = null;
    var fallback = false;
    var fallbackIndex = 0;
    var paused = false;
    var inViewport = true;
    var attempts = 0;
    var startX = null;
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(connection && connection.saveData);
    var slowConnection = !!(connection && (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g'));
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (reduceMotion) autoplayEnabled = false;

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function activeIndex() {
      if (swiper) return Number(swiper.activeIndex || 0);
      return fallbackIndex;
    }

    function activeContent() {
      return slideContent[activeIndex()] || slideContent[0] || null;
    }

    function pauseVideos() {
      var videos = root.querySelectorAll('[data-kkm-hero-video]');
      each(videos, function (video) {
        try { video.pause(); } catch (e) {}
      });
    }

    function revealVideo(video, shouldPlay) {
      if (!video || saveData || slowConnection || reduceMotion) return;
      var sources = video.querySelectorAll('source[data-src]');
      var i;
      if (video.getAttribute('data-loaded') !== 'true') {
        for (i = 0; i < sources.length; i += 1) sources[i].src = sources[i].getAttribute('data-src');
        video.setAttribute('data-loaded', 'true');
        try { video.load(); } catch (e1) {}
      }
      if (shouldPlay) {
        try {
          var playResult = video.play();
          if (playResult && typeof playResult['catch'] === 'function') playResult['catch'](function () {});
        } catch (e2) {}
      }
    }

    function prepareVideos() {
      var index = activeIndex();
      each(slideContent, function (slide, i) {
        var video = slide.querySelector('[data-kkm-hero-video]');
        if (!video) return;
        if (i === index) revealVideo(video, true);
        else {
          try { video.pause(); } catch (e) {}
        }
      });
      if (!saveData && !slowConnection && !reduceMotion && slideContent.length > 1) {
        var next = slideContent[(index + 1) % slideContent.length];
        if (next) revealVideo(next.querySelector('[data-kkm-hero-video]'), false);
      }
    }

    function durationFor(index) {
      var slide = slideContent[index] || slideContent[0];
      var value = slide ? Number(slide.getAttribute('data-duration-ms') || 6000) : 6000;
      if (!value || value < 4000) value = 4000;
      return value;
    }

    function updateFallbackUI() {
      each(wrappers, function (wrapper, i) {
        if (i === fallbackIndex) addClass(wrapper, 'kkm-hero-fallback-active');
        else removeClass(wrapper, 'kkm-hero-fallback-active');
        wrapper.setAttribute('aria-hidden', i === fallbackIndex ? 'false' : 'true');
      });
      var dots = root.querySelectorAll('[data-kkm-fallback-dot]');
      each(dots, function (dot, i) {
        dot.setAttribute('aria-current', i === fallbackIndex ? 'true' : 'false');
        if (i === fallbackIndex) addClass(dot, 'is-active');
        else removeClass(dot, 'is-active');
      });
      prepareVideos();
    }

    function schedule() {
      clearTimer();
      if (!autoplayEnabled || paused || !inViewport || document.hidden || wrappers.length < 2) return;
      timer = window.setTimeout(function () {
        if (paused || document.hidden) return;
        if (swiper) {
          if (activeIndex() >= wrappers.length - 1) swiper.slideTo(0);
          else swiper.slideNext();
        } else if (fallback) {
          fallbackIndex = (fallbackIndex + 1) % wrappers.length;
          updateFallbackUI();
          schedule();
        }
      }, durationFor(activeIndex()));
    }

    function enhanceSwiperPagination() {
      var bullets = root.querySelectorAll('.swiper-pagination-bullet');
      each(bullets, function (bullet, index) {
        bullet.setAttribute('role', 'button');
        bullet.setAttribute('tabindex', '0');
        bullet.setAttribute('aria-label', 'Go to banner ' + (index + 1));
        if (bullet.getAttribute('data-kkm-keyboard') === 'true') return;
        bullet.setAttribute('data-kkm-keyboard', 'true');
        bullet.addEventListener('keydown', function (event) {
          var key = event.key || event.keyCode;
          if (key !== 'Enter' && key !== ' ' && key !== 13 && key !== 32) return;
          if (event.preventDefault) event.preventDefault();
          bullet.click();
        });
      });
    }

    function bindSwiper(candidate) {
      if (!candidate || swiper === candidate) return;
      swiper = candidate;
      fallback = false;
      removeClass(root, 'kkm-hero-fallback');
      each(wrappers, function (wrapper) {
        removeClass(wrapper, 'kkm-hero-fallback-active');
        wrapper.removeAttribute('aria-hidden');
      });
      if (candidate.on) {
        candidate.on('slideChange', function () {
          prepareVideos();
          enhanceSwiperPagination();
          schedule();
        });
      }
      enhanceSwiperPagination();
      prepareVideos();
      schedule();
    }

    function createFallbackDots() {
      var pagination = root.querySelector('.swiper-pagination');
      if (!pagination || pagination.querySelector('[data-kkm-fallback-dot]')) return;
      var i;
      for (i = 0; i < wrappers.length; i += 1) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kkm-hero-fallback-dot';
          dot.setAttribute('data-kkm-fallback-dot', 'true');
          dot.setAttribute('aria-label', 'Go to banner ' + (index + 1));
          dot.addEventListener('click', function () {
            fallbackIndex = index;
            updateFallbackUI();
            schedule();
          });
          pagination.appendChild(dot);
        }(i));
      }
    }

    function startFallback() {
      if (swiper || fallback) return;
      fallback = true;
      addClass(root, 'kkm-hero-fallback');
      fallbackIndex = 0;
      createFallbackDots();
      updateFallbackUI();

      var next = root.querySelector('.swiper-button-next');
      var prev = root.querySelector('.swiper-button-prev');
      if (next) next.addEventListener('click', function (event) {
        if (event && event.preventDefault) event.preventDefault();
        fallbackIndex = (fallbackIndex + 1) % wrappers.length;
        updateFallbackUI();
        schedule();
      });
      if (prev) prev.addEventListener('click', function (event) {
        if (event && event.preventDefault) event.preventDefault();
        fallbackIndex = (fallbackIndex - 1 + wrappers.length) % wrappers.length;
        updateFallbackUI();
        schedule();
      });

      root.addEventListener('touchstart', function (event) {
        if (event.touches && event.touches.length === 1) startX = event.touches[0].clientX;
      }, false);
      root.addEventListener('touchend', function (event) {
        if (startX === null || !event.changedTouches || !event.changedTouches.length) return;
        var delta = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        fallbackIndex = delta < 0 ? (fallbackIndex + 1) % wrappers.length : (fallbackIndex - 1 + wrappers.length) % wrappers.length;
        updateFallbackUI();
        schedule();
      }, false);
      schedule();
    }

    function findSwiper() {
      var candidate = sliderElement && sliderElement.swiper ? sliderElement.swiper : null;
      if (candidate) {
        bindSwiper(candidate);
        return;
      }
      attempts += 1;
      if (attempts < 80) window.setTimeout(findSwiper, 35);
      else startFallback();
    }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () { paused = true; clearTimer(); pauseVideos(); });
      root.addEventListener('mouseleave', function () { paused = false; prepareVideos(); schedule(); });
      root.addEventListener('focusin', function () { paused = true; clearTimer(); pauseVideos(); });
      root.addEventListener('focusout', function (event) {
        var next = event.relatedTarget;
        if (next && root.contains(next)) return;
        paused = false;
        prepareVideos();
        schedule();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimer(); pauseVideos(); }
      else { prepareVideos(); schedule(); }
    });

    if ('IntersectionObserver' in window) {
      try {
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries && entries[0];
          inViewport = entry ? entry.isIntersecting : true;
          if (!inViewport) { clearTimer(); pauseVideos(); }
          else { prepareVideos(); schedule(); }
        }, { threshold: 0.15 });
        observer.observe(root);
      } catch (e3) {}
    }

    findSwiper();
  }

  function initAll() {
    var roots = document.querySelectorAll('kkm-hero-media');
    each(roots, initHero);
  }

  onReady(initAll);
  document.addEventListener('shopify:section:load', initAll);
}());
